//# sourceMappingURL=my-marked-date.interface.js.map


//////////////////
// WEBPACK FOOTER
// ./~/mydatepicker/dist/interfaces/my-marked-date.interface.js
// module id = 355
// module chunks = 3